// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1154":"4608ea09","1406":"801481e9","2529":"4608ea09","4630":"7a035314","7528":"ee0381ec"}[chunkId] + ".chunk.css";
};